import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: 'Нови продукти от портфолиото на team.blue',
	blockDesc: 'Интелигентни решения за всеки бизнес.',
	blockContent:
	  [
		  {
			  page: 'WordPressAI',
			  title: '<a href="' + getInitialMeta('siteURL') + 'managed-wp-hosting.php">Хостинг за WordPress + AI асистент</a>',
			  subTitle: 'Бъдещето е вече тук',
			  desc: 'Идеален за начинаещи в WordPress. Подкрепен със силата на изкуствения интелект.',
			  buttonText: 'Виж планове и цени',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'managed-wp-hosting.php?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  },
		  {
			  page: 'GDPRProtect',
			  title: '<a href="' + getInitialMeta('siteURL') + 'gdpr-protect-iubenda">GDPR Protect</a>',
			  subTitle: 'Изряден сайт за минути',
			  desc: 'Готово решение, което осигурява пълна GDPR съвместимост за всеки бизнес.',
			  buttonText: 'Виж планове и цени',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'gdpr-protect-iubenda?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  }
	  ]
};

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: 'New products from the team.blue portfolio',
	blockDesc: 'Smart solutions for every business.',
	blockContent:
	  [
		  {
			  page: 'WordPressAI',
			  title: '<a href="' + getInitialMeta('siteURL') + 'managed-wp-hosting.php">Hosting for WordPress +AI Assistant</a>',
			  subTitle: 'The future is already here',
			  desc: 'Ideal for WordPress beginners. Powered by the strength of artificial intelligence.',
			  buttonText: 'View Plans & Pricing',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'managed-wp-hosting.php?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  },
		  {
			  page: 'GDPRProtect',
			  title: '<a href="' + getInitialMeta('siteURL') + 'gdpr-protect-iubenda">GDPR Protect</a>',
			  subTitle: 'A compliant website in minutes',
			  desc: 'A ready-made solution that ensures full GDPR compliance for any business.',
			  buttonText: 'View Plans & Pricing',
			  buttonAction: 'RedirectTo',
			  buttonParams: [
				  getInitialMeta('siteURL') + 'gdpr-protect-iubenda?tab=prices'
			  ],
			  ButtonModal: '',
			  buttonModalParams: {}
		  }
	  ]
};

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];